import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { BehaviorSubject, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { Feature, Features } from '../../business-entities/user-role-view-model';
import { RolesRightsService } from '../../business-services/roles-rights.service';
import * as Enums from '../../../../../Autofacets-Core/src/app/utils/enums';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';

@Component({
  selector: 'app-feature',
  templateUrl: './feature.component.html'
})
export class FeatureComponent implements OnInit , OnDestroy{
  features: Features[] = [];
  featureList: any[] = [];
  feature:Feature[] = [];
  userRoles: any[] = [];
  loggedinUserRoleId: number;
  paginationSub: Subscription;
  isParentDmsFlagEnabled: boolean = false;
  userRoleRightsDetails: UserRoleMenu;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
        public pService: CustomPaggerService,
        private rolesRightsService: RolesRightsService,
        public spinner: NgxSpinnerService,
        public router: Router,
        private userService: UserDataService,
        private toaster: ToastrService, private translate : TranslateService,
        private secureStorage: SecureStorage,
  ) {
    this.pService.pageSize = 20;
        this.pService.searchby = ['featureName', 'isActive'];
        this.pService.searchTerm = '';
   }

  ngOnInit(): void {
    this.pService.dataSource = [];
    this.loggedinUserRoleId = this.userService.currentUserValue.roleType;
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Feature);
    this.GetFeature();
  }

  GetFeature(){
    this.spinner.show();
    this.secureStorage.removeKey('feature');
    this.rolesRightsService.getFeatures().then((res)=>{
      if(res.responseObject.errorCount === 0){
        this.features = res.responseObject.result;
        this.pService.dataSource = this.features;
        this.secureStorage.setKeyData('feature', this.features);
        this.checkAndSetParentDmsFlag(this.features);
        this.paginationSub = this.pService.dealers$.subscribe((feature: Features[]) => {
            this.featureList = feature.map((role, index) => ({ ...role, row: this.currentPageNumber(index) }))
            this.checkAndSetParentDmsFlag(this.featureList);
            if (this.isParentDmsFlagEnabled === false)
              this.disableChildFeatures();
        });
      }
    })
    this.spinner.hide();
  }

  private checkAndSetParentDmsFlag(features: any) {
    if (features != null || features != undefined) {
      let parentDmsFeature = features.find(x => x.isMainDMSFeature === true);
      if (parentDmsFeature != null || parentDmsFeature != undefined)
        this.isParentDmsFlagEnabled = parentDmsFeature.isActive;
    }
  }

  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
        rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
        rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }
    return rtPageNumber;
}

ngOnDestroy() {
  if (this.paginationSub) {
    this.paginationSub.unsubscribe();
  }
  this.pService.dealers$ = new BehaviorSubject<any[]>([]);
  this.pService.total$ = new BehaviorSubject<number>(0);
}
onSort({ column, direction }: SortEvent) {
  this.headers.forEach(header => {
      if (header.sortable !== column) {
          header.direction = '';
      }
  });

  this.pService.sortColumn = column;
  this.pService.sortDirection = direction;
}

onSaveChanges(featureList:any[]){
  this.feature = []
  featureList.forEach(element => {
    const model={
      featureCode:'',
      isActive:false
    }
    model.featureCode = element.featureCode;
    model.isActive = element.isActive;
    this.feature.push(model);
  });
  this.spinner.show();
  let errorMsg = this.translate.instant("lblFeatureNotUpdated");
  let successMsg = this.translate.instant("lblFeatureUpdated")

  this.rolesRightsService.updateFeature(this.feature).then((res) => {
    if(res.responseObject.result === true){
      this.GetFeature();
      this.toaster.success(successMsg)
    }
    else{
      this.toaster.error(errorMsg)
    }
  })
  this.spinner.hide();
}

  // checkDependencyOnParentDmsFlag(feature: Features) {
  //   if ((feature != null || feature != undefined) && (this.featureList != null || this.featureList != undefined)) {
  //     if (feature.isDependOnMainDMSFeature === true) {
  //       let isParentActive = false;
  //       let parentDmsFeature = this.featureList.find(x => x.isMainDMSFeature === true);
  //       if (parentDmsFeature != null || parentDmsFeature != undefined) {
  //         isParentActive = parentDmsFeature.isActive;
  //         if (isParentActive === false) {
  //           this.toaster.error(this.translate.instant('lblParentFeatureEnableRequired'));
  //           feature.isActive = false;
  //         }
  //       }
  //     }
  //     else if (feature.isMainDMSFeature === true && feature.isActive === false) {
  //       this.isParentDmsFlagEnabled = false;
  //       this.toaster.warning(this.translate.instant('lblChildFeatureWillBeDisabled'));
  //       this.disableChildFeatures();
  //     }
  //     else if (feature.isMainDMSFeature === true && feature.isActive === true) {
  //       this.isParentDmsFlagEnabled = true;
  //     }
  //   }
  // }
  checkDependencyOnParentDmsFlag(feature: Features) {
    if (!feature || !this.featureList) {
      return;
    }
  
    if (feature.isDependOnMainDMSFeature === true) {
      const parentDmsFeature = this.featureList.find(x => x.isMainDMSFeature === true);
      if (parentDmsFeature && !parentDmsFeature.isActive) {
        this.toaster.error(this.translate.instant('lblParentFeatureEnableRequired'));
        feature.isActive = false;
      }
    } else if (feature.isMainDMSFeature === true) {
      if (feature.isActive === false) {
        this.isParentDmsFlagEnabled = false;
        this.toaster.warning(this.translate.instant('lblChildFeatureWillBeDisabled'));
        this.disableChildFeatures();
      } else {
        this.isParentDmsFlagEnabled = true;
      }
    }
  }

  private disableChildFeatures() {
    let childFeatures = this.featureList.filter(x => x.isDependOnMainDMSFeature === true);
    childFeatures.forEach(f => {
      f.isActive = false;
    });
  }
}
